import React from "react"
import { Tooltip } from "antd"
import { HomeOutlined } from "@ant-design/icons"
import Strings from "utils/strings"
import { RouteAddress } from "../../types"
import { TOOLTIP_COLOR, formatClock } from "./utils"

const DepotMarker: React.FC<{
	addr: RouteAddress
	left: number
	color: string
}> = ({ addr, left, color }) => {
	// Same field AddressCard.tsx uses for every stop, depot included — `etd`
	// isn't a reliable alternative for a depot leg.
	const time = addr.eta

	const tooltipContent = (
		<div style={{ minWidth: 160 }}>
			<div style={{ fontWeight: 600, marginBottom: 4 }}>
				{Strings.routes.timelineLegendDepot}
			</div>
			{addr.address && <div style={{ color: "#bfbfbf" }}>{addr.address}</div>}
			<div style={{ marginTop: 4 }}>{formatClock(time)}</div>
		</div>
	)

	return (
		<Tooltip title={tooltipContent} color={TOOLTIP_COLOR}>
			<div
				style={{
					position: "absolute",
					left: `${left}%`,
					top: "50%",
					transform: "translate(-50%, -50%)",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					width: 24,
					height: 24,
					background: "#fff",
					border: `2px solid ${color}`,
					borderRadius: 7,
					boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
					zIndex: 1,
				}}
			>
				<HomeOutlined style={{ color, fontSize: 13 }} />
			</div>
		</Tooltip>
	)
}

export default DepotMarker
